import { render, staticRenderFns } from "./BussBulletinListPop.vue?vue&type=template&id=69aa1de0&"
import script from "./BussBulletinListPop.vue?vue&type=script&lang=js&"
export * from "./BussBulletinListPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports